<!-- Schalter „Darstellung umdrehen“ der hochkant gestellten Knopfraster (`InstrumentBody`, `BassBoard`); sitzt absolut oben rechts im Raster. -->
<script setup lang="ts">
import {Icon} from '@iconify/vue'

const flipped = defineModel<boolean>('flipped', {required: true})
</script>

<template>
  <button
      type="button"
      class="absolute top-1 right-1 z-10 rounded p-1 text-gray-500 hover:bg-gray-200/70"
      :aria-pressed="flipped"
      aria-label="Darstellung umdrehen"
      title="Darstellung umdrehen"
      @click="flipped = !flipped"
  >
    <Icon icon="lucide:arrow-up-down"/>
  </button>
</template>
